module.exports = __webpack_public_path__ + "img/rating_star.2858cd08.svg";